import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { DayListEntryType, ROLES } from '../../resources-list.component';

@Component({
  selector: 'app-resources-data',
  templateUrl: './resources-data.component.html',
  styleUrls: ['./resources-data.component.scss']
})
export class ResourcesDataComponent implements OnInit, OnChanges {

  @Input() data: Array<DayListEntryType> = [];

  public sums: { [key: string]: number } = {};

  constructor() { }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.data) {
      this.calculateSums();
    }
  }

  private calculateSums(): void {
    this.sums = {
      moderator: 0,
      moderator_external: 0,
      observer: 0,
      observer_gem: 0
    };
    this.data.forEach((entry: DayListEntryType) => {
      ROLES.forEach((role: string) => {
        if (this.sums[role] === undefined) {
          this.sums[role] = 0;
        }
        this.sums[role] += entry[role];
      });
    });
  }

}
